import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/VV_Logo.png'


const _hoisted_1 = { class: "flex items-center relative pe-2" }

import { ref, onMounted} from 'vue';
import {useRouter} from 'vue-router';
import { useModeStore } from '@/stores/modeStore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import UserDropdown from '@/components/layout/header/UserDropdown.vue';
import ShoppingCartButton from '@/components/layout/header/ShoppingCartButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

gsap.registerPlugin(ScrollTrigger);
const router =  useRouter();
const navRef = ref<HTMLElement | null>(null);
const modeStore = useModeStore();
const itemsInCart = ref<number>(0);

function selectMode(mode: 'hifi' | 'studio') {
  modeStore.setMode(mode);
  // redirect logic could be done here if not already handled elsewhere
}

const handleGoToHome = () => {
  router.push({ name: 'product-detail' });
};

onMounted(() => {

  const logo = document.querySelector('.logo');

  gsap.to(logo, {
    duration: 1.5,
    repeat: -1,
    yoyo: true,
    ease: 'Power1.inOut',
    filter:'drop-shadow(0 0 5px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 10px rgba(173, 216, 230, 0.8))',
    onStart: () => {
      // Set the initial filter state
      gsap.set(logo, {
        filter: 'drop-shadow(0 0 5px rgba(255, 255, 255, 0.5))'
      });
    },
  });
  const navEl = navRef.value;

  let lastDirection = 1;

  gsap.set(navEl, { y: 0, autoAlpha: 1 });

  gsap.from(navRef.value, {
    y: -60,
    opacity: 0,
    duration: 1,
    ease: 'power2.out'
  });

  ScrollTrigger.create({
    start: 0,
    end: 'bottom bottom',
    onUpdate: (self) => {
      const dir = self.direction;

      // Scroll down (hide nav)
      if (dir === 1 && lastDirection !== 1) {
        gsap.to(navEl, {
          duration: 0.4,
          y: -100,
          autoAlpha: 0,
          ease: 'power2.out',
        });
        lastDirection = 1;
      }

      // Scroll up (show nav)
      if (dir === -1 && lastDirection !== -1) {
        gsap.to(navEl, {
          duration: 0.4,
          y: 0,
          autoAlpha: 1,
          ease: 'power2.out',
        });
        lastDirection = -1;
      }
    },
  });

});

//onUnmounted(() => { });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    ref_key: "navRef",
    ref: navRef,
    class: "navbar"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Valve Vista Logo",
        class: "logo"
      })
    ], -1)),
    _createElementVNode("div", null, [
      _createElementVNode("ul", { class: "nav-links gap-4 md:gap-16" }, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "text-xs md:text-base lg:text-lg",
            onClick: handleGoToHome
          }, "Home")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "text-xs md:text-base lg:text-lg",
            onClick: handleGoToHome
          }, "Products")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "text-xs md:text-base lg:text-lg",
            onClick: handleGoToHome
          }, "Testimonials")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "text-xs md:text-base lg:text-lg",
            onClick: handleGoToHome
          }, "News")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UserDropdown),
      _createVNode(ShoppingCartButton)
    ])
  ], 512))
}
}

})